import Section from "@components/Chatbot/Summary/Section.tsx";
import BarChartHighcharts from "@components/Charts/BarChart";
import React from "react";
import BarChart from "@components/Charts/BarChart";
import {mapDataForFPTestingHighcharts} from "@mappers/model/FPTestingBarChartMapper";
import {useSelector} from "react-redux";
import AsymChartExample from "@components/Charts/AsymChartExample";
import ChartErrorBoundary from "@components/Chatbot/Summary/ErrorBoundary";

const TestingCharts = ({ charts }) => {
    const {
        info: {
            team_colors: teamColors,
            display_name: teamName,
            metric: teamMetric,
            acwr_threshold_config: acwrThresholdConfig
        },
    } = useSelector(({ team }) => team);

    const isAsym = (config) => {
        return config?.optionsV2 && config?.optionsV2?.length > 1;
    }

    if (!charts?.length) {
        return (
            <p style={{ textAlign: "center", color: "black", margin: 0, opacity: 0.4 }}>
                No relevant Testing data available.
            </p>
        )
    }

    return (
        <>
            {
                charts?.map((chart, index) => {
                    if (isAsym(chart)) {
                        return (
                            <ChartErrorBoundary
                                componentLabel={`Chart ${index + 1}`}
                                mergedOptions={chart}
                            >
                                <div className="fp-testing-chart" style={{ width: "48%"}} key={index}>
                                    <AsymChartExample
                                        data={chart?.data || []}
                                        metric={chart?.optionsV2[0]}
                                        stat={"avg"}
                                        showTitle={true}
                                        enableDrillDown={false}
                                    >
                                    </AsymChartExample>
                                </div>
                            </ChartErrorBoundary>

                        )
                    } else {
                        const options = mapDataForFPTestingHighcharts({
                            dataIn: chart,
                            metric: chart?.optionsV2[0],
                            singleAxis: true,
                            isForcePlateMetric: false,
                            isTestingMetric: true,
                            teamColors: teamColors.all,
                            teamName,
                            teamMetric,
                            stat: "avg",
                            acwrThresholdConfig,
                            showTitle: true,
                            enableDrillDown: false,
                        })
                        return (
                            <ChartErrorBoundary
                                componentLabel={`Chart ${index + 1}`}
                                mergedOptions={chart}
                            >
                                <div className="fp-testing-chart" style={{ width: "48%"}} key={index}>
                                    <BarChart
                                        options={options}
                                    />
                                </div>
                            </ChartErrorBoundary>
                        )
                    }
                })
            }
        </>
    )
}

const DummyTestingSection = ({ summaryContent }) => {
    const testingData = summaryContent?.testing;

    return (
        <Section
            title={"Testing"}
        >
            <div className={"chat-summary-charts-container"}>
                <TestingCharts charts={testingData?.charts} />
            </div>
        </Section>

    );
}

export default DummyTestingSection;